import {faBell} from "@fortawesome/pro-solid-svg-icons/faBell";
import {faCircleQuestion} from "@fortawesome/pro-solid-svg-icons/faCircleQuestion";
import {faSliders} from "@fortawesome/pro-solid-svg-icons/faSliders";
import {faPersonToDoor} from "@fortawesome/pro-solid-svg-icons/faPersonToDoor";
import {ColourSolid} from "@twigsby/frontend-framework";
import Preferences from "../../Pages/User/Plan/Preferences";
import {SuggestibleRouteInterface} from "../TopRoutes";

const SiteSettingsRoutes: Array<SuggestibleRouteInterface> = [
    {
        title: 'Preferences',
        path: '/manage-account/site-settings/preferences',
        icon: faSliders,
        element: <Preferences />,
        colour: ColourSolid.Danger,
        group: 'Site Details'
    },
    {
        title: 'Notifications',
        path: '/manage-account/site-settings/notifications',
        icon: faBell,
        element: <Preferences />,
        colour: ColourSolid.Danger,
        group: 'Site Details'
    },
    {
        title: 'Help',
        path: '/manage-account/site-settings/help',
        icon: faCircleQuestion,
        element: <Preferences />,
        colour: ColourSolid.Danger,
        group: 'Site Details'
    },
    {
        title: 'Logout',
        path: '/manage-account/site-settings/logout',
        icon: faPersonToDoor,
        element: <Preferences />,
        colour: ColourSolid.Danger,
        group: 'Site Details'
    },
]

export { SiteSettingsRoutes }
